import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (route.queryParamMap.has('token')) {
      let { token, expiry, ...newQueryParams } = route.queryParams;
      let path = state.url.substring(0, state.url.indexOf('?'));
      this.authService.token = { value: token, expiry: expiry || moment().add(720, 'minutes') };
      this.router.navigate([path], { queryParams: newQueryParams, replaceUrl: true });
      return false;
    }
    if (!this.authService.token) {
      this.router.navigate(['/unauthorized']);
      return false;
    }
    return true;
  }

}



// WEBPACK FOOTER //
// ./src/app/core/auth-guard.service.ts